
export default {

  async placeOrder(id){
    return 'Not implemented for QP'
  },
}
